import { genericService } from "./genericService";
import { akeronService } from "./akeronService";

const section = "StockWarehouse";

function getAllContainers() {
  return akeronService.make_get_request(section + "/GetAllContainers").then((response) => {
    let result = {
      quantity: response.quantity,
      list: response.containers,
    };
    return result;
  });
}

function filter(name = "", from = "0", limit = "10") {
  const param = {
    jtStartIndex: parseInt(from),
    jtPageSize: parseInt(limit),
    Name: name,
  };
  
  return akeronService.make_post_request(section + "/ListContainers", param).then((response) => {
    let result = {
      quantity: response.quantity || response.length,
      list: response.containers || response,
    };
    return result;
  });
}

function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  return genericService.create(section, item);
}

function update(item) {
  return genericService.update(section, item);
}

export const contenedoresService = {
  getAllContainers,
  filter,
  remove,
  create,
  update,
};
